export default "__VITE_ASSET__Sa7v6DWV__"